/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TechStackCompanyPageRequestDto } from '../models/tech-stack-company-page-request-dto';
import { TechStackCompanyProductPageRequestDto } from '../models/tech-stack-company-product-page-request-dto';
import { TechStackCompanyProductPageResponseDto } from '../models/tech-stack-company-product-page-response-dto';
import { TechStackPageResponseDto } from '../models/tech-stack-page-response-dto';

@Injectable({
  providedIn: 'root',
})
export class TechStackService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation findStacks
   */
  static readonly FindStacksPath = '/techstacks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findStacks$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findStacks$Json$Response(params?: {
    body?: TechStackCompanyPageRequestDto
  }): Observable<StrictHttpResponse<TechStackPageResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.FindStacksPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TechStackPageResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findStacks$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findStacks$Json(params?: {
    body?: TechStackCompanyPageRequestDto
  }): Observable<TechStackPageResponseDto> {

    return this.findStacks$Json$Response(params).pipe(
      map((r: StrictHttpResponse<TechStackPageResponseDto>) => r.body as TechStackPageResponseDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findStacks$Csv()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findStacks$Csv$Response(params?: {
    body?: TechStackCompanyPageRequestDto
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.FindStacksPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/csv'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findStacks$Csv$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findStacks$Csv(params?: {
    body?: TechStackCompanyPageRequestDto
  }): Observable<string> {

    return this.findStacks$Csv$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation findTechStackProducts
   */
  static readonly FindTechStackProductsPath = '/techstacks/products';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findTechStackProducts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findTechStackProducts$Response(params?: {
    body?: TechStackCompanyProductPageRequestDto
  }): Observable<StrictHttpResponse<TechStackCompanyProductPageResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.FindTechStackProductsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TechStackCompanyProductPageResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findTechStackProducts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findTechStackProducts(params?: {
    body?: TechStackCompanyProductPageRequestDto
  }): Observable<TechStackCompanyProductPageResponseDto> {

    return this.findTechStackProducts$Response(params).pipe(
      map((r: StrictHttpResponse<TechStackCompanyProductPageResponseDto>) => r.body as TechStackCompanyProductPageResponseDto)
    );
  }

}
